import React from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "@/components/hx/Navbar";
import { Footer } from "@/components/hx/Footer";
import { PageHeader } from "@/components/hx/PageHeader";
import { Contact } from "@/components/hx/sections/Contact";
import { useLangSync } from "@/hooks/useLangSync";

export default function ContactPage() {
  useLangSync();
  const { t } = useTranslation();
  return (
    <div className="App relative bg-hx-bg text-hx-text" data-testid="page-contact">
      <Navbar />
      <main>
        <PageHeader
          breadcrumb={t("pages.contact.breadcrumb")}
          eyebrow={t("pages.contact.eyebrow")}
          title={t("pages.contact.title")}
          accent={t("pages.contact.accent")}
          lede={t("pages.contact.lede")}
        />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
